import { getCurrentLocalDate } from '../../../../api/apiClient';

/** Format a Date as YYYY-MM-DD using local date parts (avoids UTC-offset day-shift). */
export const formatDate = (date: Date | null): string => {
  if (!date) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const computeBannerStatus = (start: string, end: string): 'Active' | 'Scheduled' | 'Expired' => {
  const today = getCurrentLocalDate();
  if (end < today) return 'Expired';
  if (start > today) return 'Scheduled';
  return 'Active';
};

/** Returns true if the [start, end] range overlaps any banner in the list (excluding the banner with excludeId). */
export const hasBannerOverlap = (
  start: string,
  end: string,
  banners: Array<{ id: string; startDate: string; endDate: string }>,
  excludeId?: string,
): boolean =>
  banners.some(
    b =>
      String(b.id) !== String(excludeId) &&
      b.startDate <= end &&
      b.endDate >= start,
  );

export const computeEventStatus = (date: string): 'Active' | 'Scheduled' | 'Expired' => {
  const today = getCurrentLocalDate();
  if (date === today) return 'Active';
  return 'Scheduled';
};

export const computeTrainingStatus = (end: string): 'Active' | 'Expired' =>
  end < getCurrentLocalDate() ? 'Expired' : 'Active';
